import { render, staticRenderFns } from "./VehiculospartidaGrid.vue?vue&type=template&id=05d4261d"
import script from "./VehiculospartidaGrid.vue?vue&type=script&lang=js"
export * from "./VehiculospartidaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports